"use client";
import Image from "next/image";
import Link from "next/link";

export default function Custom500({ error, reset }) {
  if (error && process.env.NODE_ENV !== "production") {
    console.error("Custom500 Error:", error);
  }

  return (
    <>
      <div
        style={{
          minHeight: "100vh",
          backgroundColor: "#F5F7F9",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          fontFamily: "sans-serif",
          padding: "20px",
        }}
      >
        <div style={{ marginBottom: "40px" }}>
          <Link href="/">
            <Image
              src="/omr.png"
              alt="Osmrtnica.com"
              width={255}
              height={32}
              style={{ objectFit: "contain" }}
            />
          </Link>
        </div>

        <div
          style={{
            backgroundColor: "white",
            padding: "40px",
            borderRadius: "8px",
            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.05)",
            maxWidth: "500px",
            width: "100%",
            textAlign: "center",
          }}
        >
          <h1
            style={{
              fontSize: "24px",
              fontWeight: "bold",
              color: "#dc3545",
              marginBottom: "16px",
            }}
          >
            Napaka strežnika (500)
          </h1>

          <p
            style={{
              fontSize: "16px",
              color: "#6c757d",
              marginBottom: "24px",
              lineHeight: "1.5",
            }}
          >
            Prišlo je do napake na strežniku. Prosimo, poskusite kasneje ali
            osvežite stran.
          </p>

          {error && process.env.NODE_ENV !== "production" && (
            <p
              style={{
                fontSize: "14px",
                color: "#dc3545",
                marginBottom: "24px",
                backgroundColor: "#fff5f5",
                padding: "10px",
                borderRadius: "4px",
                overflowWrap: "break-word",
              }}
            >
              Error: {error.message}
            </p>
          )}

          <p
            style={{
              fontSize: "14px",
              color: "#adb5bd",
              marginBottom: "32px",
              lineHeight: "1.5",
            }}
          >
            Server Error. Something went wrong on our end. Please try again
            later.
          </p>

          <div
            style={{
              display: "flex",
              gap: "10px",
              justifyContent: "center",
              flexWrap: "wrap",
            }}
          >
            <button
              onClick={() => reset()}
              style={{
                display: "inline-block",
                backgroundColor: "#0d6efd",
                color: "white",
                padding: "12px 24px",
                borderRadius: "6px",
                border: "none",
                cursor: "pointer",
                fontSize: "16px",
                fontWeight: "500",
                transition: "background-color 0.2s",
              }}
            >
              Poskusi ponovno
            </button>

            <Link
              href="/"
              style={{
                display: "inline-block",
                backgroundColor: "#1E2125",
                color: "white",
                padding: "12px 24px",
                borderRadius: "6px",
                textDecoration: "none",
                fontSize: "16px",
                fontWeight: "500",
                transition: "background-color 0.2s",
              }}
            >
              Nazaj na prvo stran
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}
